import { render } from "./AddFontsSideBar.vue?vue&type=template&id=6d555860"
import script from "./index?vue&type=script&lang=js&external"
export * from "./index?vue&type=script&lang=js&external"

import "./AddFontsSideBar.vue?vue&type=style&index=0&id=6d555860&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__